import {
    OPEN_COOKIE_SETTINGS,
    CLOSE_COOKIE_SETTINGS,
} from '../actions/CookieSettings';

const initialState = {
    isOpened: false,
}

export const cookieSettings = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_COOKIE_SETTINGS: {
            return {
                ...state,
                //content: action.content,
                //title: action.title,
                isOpened: true,
            }
        }
        case CLOSE_COOKIE_SETTINGS: {
            return {
                ...state,
                //content: null,
                isOpened: false,
                //title: null,
            }
        }
        default:
            return state
    }
}
